import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgThreeDots = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 23,
	height: 23,
	viewBox: "0 0 23 23",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 21.1842,
			height: 21.1842,
			rx: 10.5921,
			fill: "#F8F8F8",
			stroke: "#C8C8C8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.677 11.2398C16.0037 11.2398 16.2686 10.9749 16.2686 10.6482C16.2686 10.3215 16.0037 10.0566 15.677 10.0566C15.3503 10.0566 15.0854 10.3215 15.0854 10.6482C15.0854 10.9749 15.3503 11.2398 15.677 11.2398Z",
			stroke: "#233A59",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.5359 11.2398C11.8626 11.2398 12.1275 10.9749 12.1275 10.6482C12.1275 10.3215 11.8626 10.0566 11.5359 10.0566C11.2092 10.0566 10.9443 10.3215 10.9443 10.6482C10.9443 10.9749 11.2092 11.2398 11.5359 11.2398Z",
			stroke: "#233A59",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.3948 11.2398C7.72152 11.2398 7.98638 10.9749 7.98638 10.6482C7.98638 10.3215 7.72152 10.0566 7.3948 10.0566C7.06808 10.0566 6.80322 10.3215 6.80322 10.6482C6.80322 10.9749 7.06808 11.2398 7.3948 11.2398Z",
			stroke: "#233A59",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgThreeDots;
